"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Button = _interopRequireDefault(require("./Button")),
    _Dropdown = _interopRequireDefault(require("../../Dropdown"));

require("../styles/_button-dropdown-toggle.scss");

var TYPE_STYLES_MAP = {
  PRIMARY: !0,
  SECONDARY: !0,
  INVERTED: !0
},
    ICON_COLORS = {
  PRIMARY: "white",
  SECONDARY: "white",
  INVERTED: "black"
},
    ButtonDropdownToggle = function ButtonDropdownToggle(a) {
  var b,
      c = a.dropdownOptions,
      d = a.initialValue,
      e = a.buttonProps,
      f = a.toggleOnChange,
      g = a.buttonTextToShow,
      h = e || {},
      i = h.type,
      j = h.disabled,
      k = h.small,
      l = i || "PRIMARY",
      m = (0, _react.useState)(function getInitialToggleValue() {
    return c.find(function (a) {
      var b = a.value;
      return b === d;
    }) || c[0];
  }()),
      n = (0, _slicedToArray2["default"])(m, 2),
      o = n[0],
      p = n[1],
      q = (0, _react.useState)(!1),
      r = (0, _slicedToArray2["default"])(q, 2),
      s = r[0],
      t = r[1],
      u = (0, _react.useRef)(null),
      v = function v(a) {
    u.current && !u.current.contains(a.target) && t(!1);
  };

  (0, _react.useEffect)(function () {
    return document.addEventListener("click", v, !0), function () {
      document.removeEventListener("click", v, !0);
    };
  });
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("btn-group", {
      small: k
    }),
    "data-testid": "btn-group-testId"
  }, _react["default"].createElement(_Button["default"], e, g || o.label), _react["default"].createElement("span", {
    "data-testid": "dropdown-wrapper",
    onClick: function onDropdownClick() {
      return !j && (t(!s), !0);
    },
    onKeyDown: function onKeyDown(a) {
      return a.stopPropagation();
    },
    ref: u,
    role: "listbox",
    tabIndex: 0
  }, _react["default"].createElement(_Dropdown["default"], {
    className: (0, _classnames["default"])("btn-group__drop-down", (b = {}, (0, _defineProperty2["default"])(b, l.toLowerCase(), TYPE_STYLES_MAP[l]), (0, _defineProperty2["default"])(b, "disabled", j), (0, _defineProperty2["default"])(b, "small", k), b)),
    hideSelectedLabel: !0,
    options: c,
    defaultValue: o,
    onChange: function handleToggleChange(a) {
      p(a), f && f(a);
    },
    upperCaseLabels: !0,
    color: ICON_COLORS[l],
    menuIsOpen: s,
    fontSize: k ? 12 : 16,
    renderMenuLocally: !0
  })));
},
    _default = ButtonDropdownToggle;

exports["default"] = _default;